export default __webpack_public_path__ + "menu.2c940b86.svg";